module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921022651_T.07f5ea9f.jpg";